import gql from 'graphql-tag';
const ACTIVATE_DEMOGRAPH_AUDIENCE = gql`
  mutation activateDemographAudiences($data: JSON!) {
    activateDemographAudiences(data: $data)
  }
`;

export default ACTIVATE_DEMOGRAPH_AUDIENCE;
